export interface SkeletonProps {
  width?: string;
  height?: string;
}

function Skeleton(props: SkeletonProps) {
  const { width, height } = props;

  return (
    <div className="ct_skeleton" style={{ width, height }}>
      <div className="ct_skeleton-inner" />
    </div>
  );
}

Skeleton.defaultProps = { height: '100%', width: '100%' };

export default Skeleton;
